import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LoaderComponent } from '@elan/components/loader-component/loader-component';
@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  template: `
    <button
      type="submit"
      [disabled]="disabled || loading"
      class="cursor-pointer"
      [ngClass]="buttonClasses"
      (click)="handleClick()"
    >
      <div class="flex gap-2 items-center justify-center">
      <ng-content></ng-content>
       <app-loader [loaderId]="loaderId" size="small"  *ngIf="type === 'submit'"></app-loader>
      </div>

    </button>
  `,
  styles: [],
  host: {
    // tabindex: '0'   // Make component focusable
  }

})
export class ButtonComponent {

  /** Button label (used if you don’t pass <ng-content>) */
  @Input() label = '';

  /** Visual variants: primary, secondary, danger, outline, ghost */
  @Input() variant: 'primary' | 'secondary' | 'danger' | 'outline' | 'ghost' = 'primary';

  /** Sizes: sm, md, lg */
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  /** Optional custom classes */
  @Input() className = '';

  /** Disabled state */
  @Input() disabled = false;

  /** Show spinner */
  @Input() loading = false;

  /** Click event output */
  @Output() btnClick = new EventEmitter<void>();

  @Input() loaderId: string = '';

  @Input() type: 'submit' | 'button' | 'reset' = 'button';

  handleClick() {
    if (!this.disabled && !this.loading) {
      this.btnClick.emit();
    }
  }

  get buttonClasses(): string {
    const base = `
    text-white text-left py-3 rounded-xl font-semibold text-lg transition-all duration-200 
    hover:-translate-y-1 hover:shadow-xl hover:shadow-accent/40
    disabled:cursor-not-allowed disabled:opacity-60
    `;

    const sizes: Record<string, string> = {
      sm: 'px-3 py-1.5 text-sm',
      md: 'px-3 py-2 text-sm',
      lg: 'px-6 py-3 text-base'
    };

    const variants: Record<string, string> = {
      primary: `
        bg-primary text-white border border-transparent
        hover:bg-transparent hover:border-primary hover:text-white
      `,
      secondary: `
        bg-secondary text-primary border border-primary hover:bg-primary
        hover:text-white
      `,
      danger: `
        bg-red-600 text-white hover:bg-red-700
      `,
      outline: `
        bg-transparent text-primary border border-primary hover:bg-primary
        hover:text-white
      `,
      ghost: `
        text-text hover:bg-gray-100
      `
    };

    return `${base} ${sizes[this.size]} ${variants[this.variant]} ${this.className}`;
  }
}
